class StickyVideoWidget extends HTMLElement {
  constructor() {
    super();
    this.card = this.querySelector('[data-sticky-video-card]');
    this.backdrop = this.querySelector('[data-sticky-video-backdrop]');
    this.closeButton = this.querySelector('[data-sticky-video-close]');
    this.toggle = this.querySelector('[data-sticky-video-toggle]');
    this.video = this.querySelector('video');
    this.iframeHolder = this.querySelector('[data-sticky-video-iframe]');
  }

  connectedCallback() {
    this.closeButton.addEventListener('click', () => this.dismiss());
    this.toggle.addEventListener('click', () => this.toggleExpand());
    this.toggle.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this.toggleExpand();
      }
    });
    this.backdrop.addEventListener('click', () => {
      if (this.classList.contains('is-expanded')) this.collapse();
    });

    if (this.video) {
      this.video.muted = true;
      this.playVideo();
    }

    if (this.iframeHolder) {
      this.setIframeMuted(true);
    }
  }

  playVideo() {
    const playPromise = this.video.play();
    if (playPromise && playPromise.catch) playPromise.catch(() => {});
  }

  toggleExpand() {
    if (this.classList.contains('is-expanded')) {
      this.collapse();
    } else {
      this.expand();
    }
  }

  expand() {
    this.classList.add('is-expanded');
    document.body.classList.add('overflow-hidden');
    this.toggle.setAttribute('aria-label', window.accessibilityStrings?.collapseVideo || 'Collapse video');

    if (this.video) {
      this.video.muted = false;
      this.playVideo();
    }

    if (this.iframeHolder) this.setIframeMuted(false);
  }

  collapse() {
    this.classList.remove('is-expanded');
    document.body.classList.remove('overflow-hidden');
    this.toggle.setAttribute('aria-label', window.accessibilityStrings?.expandVideo || 'Expand video');

    if (this.video) this.video.muted = true;
    if (this.iframeHolder) this.setIframeMuted(true);
  }

  setIframeMuted(muted) {
    const provider = this.iframeHolder.dataset.provider;
    const videoId = this.iframeHolder.dataset.videoId;
    if (!provider || !videoId) return;

    let src = '';
    if (provider === 'youtube') {
      src = `https://www.youtube.com/embed/${videoId}?enablejsapi=1&autoplay=1&playsinline=1&controls=0&modestbranding=1&rel=0&loop=1&playlist=${videoId}&mute=${
        muted ? 1 : 0
      }`;
    } else if (provider === 'vimeo') {
      src = `https://player.vimeo.com/video/${videoId}?autoplay=1&loop=1&background=0&controls=0&muted=${
        muted ? 1 : 0
      }`;
    }
    if (!src) return;

    let iframe = this.iframeHolder.querySelector('iframe');
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.setAttribute('allow', 'autoplay; encrypted-media');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('title', this.iframeHolder.getAttribute('aria-label') || 'Video');
      this.iframeHolder.appendChild(iframe);
    }
    if (iframe.src !== src) iframe.src = src;
  }

  dismiss() {
    this.classList.remove('is-expanded');
    document.body.classList.remove('overflow-hidden');
    if (this.video) this.video.pause();
    this.classList.add('is-hidden');
    window.setTimeout(() => this.remove(), 300);
  }
}

customElements.define('sticky-video-widget', StickyVideoWidget);
